import { FiClock, FiCreditCard, FiShield } from "react-icons/fi";
import { BrandPanel, BrandFeature } from "./AuthLayout";

export const AUTH_PANEL_IMAGE =
  "https://storageaccountzampl852f.blob.core.windows.net/zamplia-survey-images/grupSignup.avif";

export const AUTH_FEATURES: BrandFeature[] = [
  {
    icon: FiClock,
    title: "Quick surveys, any time",
    text: "Turn a few spare minutes into rewards for your opinions.",
  },
  {
    icon: FiCreditCard,
    title: "Get paid with a Visa card",
    text: "Redeem the points you earn for cash rewards and gift cards.",
  },
  {
    icon: FiShield,
    title: "Privacy protected",
    text: "Your profile and survey answers are kept private.",
  },
];

export const ImageComponent = () => {
  return (
    <BrandPanel
      eyebrow="Zamplia Surveys"
      title={
        <>
          Start earning <span className="text-primary-text">cash rewards</span> for your opinions
        </>
      }
      description="Get rewarded for minutes of feedback. Join the community."
      features={AUTH_FEATURES}
      image={AUTH_PANEL_IMAGE}
      imageAlt="People taking part in surveys"
    />
  );
};
